import React, { useState, useRef, useEffect } from 'react'
import { useQuery } from 'react-query'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'
import { taskService } from '@/services/taskService'
import TaskTypeIcon from './TaskTypeIcon'

const TASK_TYPE_KEY = 'last-task-type-id'

const TaskForm = ({ onSubmit, onCancel, loading }) => {
  const [title, setTitle] = useState('')
  const [typeId, setTypeId] = useState(() => parseInt(localStorage.getItem(TASK_TYPE_KEY)) || 1)
  const ref = useRef(null)

  const { data: typesData } = useQuery(
    'task-types',
    () => taskService.getTaskTypes(),
    { staleTime: 60000 * 5 }
  )
  const taskTypes = typesData?.data?.types || []

  useEffect(() => { ref.current?.focus() }, [])

  const handleSubmit = () => {
    if (!title.trim()) return
    localStorage.setItem(TASK_TYPE_KEY, String(typeId))
    onSubmit(title.trim(), typeId)
    setTitle('')
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit()
    }
    if (e.key === 'Escape') onCancel()
  }

  return (
    <div className="space-y-2 p-2 bg-muted/50 rounded-lg border border-dashed">
      <Textarea
        ref={ref}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Task title... (Enter to add)"
        className="text-sm resize-none min-h-[60px] bg-background"
        rows={2}
      />
      <div className="flex items-center gap-2">
        <div className="flex items-center border rounded-md overflow-hidden">
          {taskTypes.map((t) => {
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => setTypeId(t.id)}
                className={cn(
                  'flex items-center gap-0.5 px-1.5 py-1 text-[10px] font-medium transition-colors',
                  typeId === t.id ? 'bg-muted' : 'hover:bg-muted/50'
                )}
                title={t.name}
              >
                <TaskTypeIcon type={t} size="sm" />
                {t.name}
              </button>
            )
          })}
        </div>
        <Button size="sm" onClick={handleSubmit} disabled={!title.trim() || loading} className="h-7 text-xs">
          Add
        </Button>
        <Button size="sm" variant="ghost" onClick={onCancel} className="h-7 text-xs">
          <X className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  )
}

export default TaskForm
